import React from 'react';
import { Button, Flex, WorkInProgress } from '../common';
import { useNavigate } from 'react-router-dom';

function AppPreference() {
  const navigate = useNavigate();

  return (
    <div>
      <WorkInProgress />
      <Flex
        vertical
        justify="space-between"
        className=" w-full text-white mt-auto "
      >
        <Flex
          justify="end"
          className={`sticky bottom-0 w-full  lg:justify-between justify-end  p-4 border-t h-[56px] md:h-[72px] border-[#7C30F7]  bg-primaryLight `}
        >
          <Button
            text="Back"
            onClick={() => {
              navigate(-1);
            }}
            buttonProps={{ type: 'primary-none' }}
          />
        </Flex>
      </Flex>
    </div>
  );
}

export default AppPreference;
